import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

// Seeded static photos live under /images (frontend); uploaded photos are served
// by the backend under /api/... — resolve those to an absolute backend URL.
export const resolvePhoto = (p) => {
  if (!p) return null;
  return p.startsWith("/api") ? `${BACKEND}${p}` : p;
};

const TOKEN_KEY = "wf_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
